import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { Growl } from 'angular/custom/services/growl.service';
import * as angular from 'angular';

class NetworkPointDetailsOperatorInfoLeadTimesComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public loggedInUser: any;
    public leadTimesExpanded: boolean = true;
    public networkPoint: NetworkPointDto;

    public isLoggedIn: boolean;
    public canEditLeadTimes: boolean = false;
    public leadTimesEnabled: boolean = false;
    public fcfsEnabled: boolean = false;

    public creatingLeadTimeRule: boolean = false;
    public newLeadTimeRule: LeadTimeRuleDto;
    public leadTimeRules: LeadTimeRuleDto[] = [];

    public uiLoadingLeadTimes: boolean = true;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private errorHandler: ErrorHandler,
        private $q: ng.IQService,
        private growl: Growl
    ) {}

    $onInit(): void {
        if (!this.isCreateMode) {
            this.canEditLeadTimes =
                !this.networkPoint.bundled &&
                this.loggedInUser.role === 'TSO_USER' &&
                this.loggedInUser.referenceId === this.networkPoint.tso0Id;

            if (this.canEditLeadTimes) {
                this.loadExistingLeadTimes();
            } else {
                this.uiLoadingLeadTimes = false;
            }
        }
    }

    private loadExistingLeadTimes(): void {
        let settingsPromise = this.TransmissionSystemOperator.queryFcfsSettings(
            { id: this.networkPoint.tso0Id },
            (result: TsoFcfsSettingsDto) => {
                this.fcfsEnabled = angular.isUndefined(result.portalUrl);
                this.leadTimesEnabled =
                    result.leadTimeRules.length > 0 ||
                    !angular.isUndefined(result.leadTimeDescription);
            }
        ).$promise;
        let leadTimePromise =
            this.TransmissionSystemOperator.queryFcfsLeadTimesAtNetworkPoint(
                {
                    id: this.networkPoint.tso0Id,
                    npId: this.networkPoint.id
                },
                (result: LeadTimeRuleDto[]) => {
                    this.leadTimeRules = result;
                }
            ).$promise;

        this.$q.all([settingsPromise, leadTimePromise]).then(() => {
            this.uiLoadingLeadTimes = false;
        });
    }

    public startAddingNewLeadTimeRule(contractPeriodType: ContractPeriodType) {
        this.creatingLeadTimeRule = true;
        let name =
            contractPeriodType === 'NON_WITHINDAY'
                ? ''
                : contractPeriodType === 'FULL_WITHINDAY'
                  ? '1st within-day'
                  : 'Subsequent within-day';
        this.newLeadTimeRule = <LeadTimeRuleDto>{
            name: name,
            mode: 'FCFS',
            contractPeriodType: contractPeriodType,
            contractPeriod: null,
            leadTimePeriodForMinimumTimeBefore: {
                value: null,
                type: 'DAY'
            },
            leadTimePeriodForMaximumTimeAhead: {
                value: null,
                type: 'DAY'
            }
        };
    }

    public deleteLeadTime(leadTimeId: number) {
        this.TransmissionSystemOperator.deleteFcfsLeadTimeRule(
            {
                id: this.loggedInUser.referenceId,
                leadTimeId: leadTimeId
            },
            () => {
                this.growl.show(
                    'The lead time was successfully deleted',
                    'success'
                );
                this.leadTimeRules.splice(
                    this.leadTimeRules.findIndex(
                        (leadTimeRule) => leadTimeRule.id === leadTimeId
                    ),
                    1
                );
                this.TransmissionSystemOperator.getNumberOfLeadTimes(
                    { id: this.loggedInUser.referenceId },
                    (num: number) => {
                        if (num === 0) {
                            this.TransmissionSystemOperator.saveFcfsLeadTimeDescription(
                                { id: this.loggedInUser.referenceId },
                                { value: null }
                            );
                        }
                    }
                );
            },
            this.errorHandler
        );
    }

    public resetNewLeadTimeRule() {
        delete this.newLeadTimeRule;
        this.creatingLeadTimeRule = false;
    }

    public getContractPeriodString(leadTimeRule: LeadTimeRuleDto) {
        if (leadTimeRule.contractPeriodType === 'SUBSEQUENT_WITHINDAY') {
            return '< 1 day';
        } else if (leadTimeRule.contractPeriodType === 'FULL_WITHINDAY') {
            return '1 day';
        } else {
            return leadTimeRule.contractPeriod
                ? '< ' +
                      leadTimeRule.contractPeriod +
                      ' month' +
                      (leadTimeRule.contractPeriod > 1 ? 's' : '')
                : 'Open end rule';
        }
    }
}

angular.module('app').component('pkpNetworkPointDetailsOperatorInfoLeadTimes', {
    controller: NetworkPointDetailsOperatorInfoLeadTimesComponentCtrl,
    template:
        require('app/network-point/network-point-details-operator-info-lead-times.component.html'),
    bindings: {
        form: '=',
        networkPoint: '=',
        isEditMode: '<',
        isCreateMode: '<',
        loggedInUser: '<'
    }
});
